import React, { Component } from 'react'

//GSAP Component
import { gsap, Power3 } from "gsap"

// Framer-motion Components
import {motion} from 'framer-motion'

// Styling
import '../Utilitaries/Services.css'
import "./HeroBanner.css"

//Photos 
import lac from "../assets/photos/lac.jpg"

class HeroBanner extends Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }

    componentDidMount(){
        const upTitle = document.querySelector('#title .upTitle')
        const downTitle = document.querySelector('#title .downTitle')
        const image = document.querySelector('.HeroBanner-img')
        const tl = new gsap.timeline({
            // stagger: true
        })

        tl.from(upTitle, 0.8,{y:200, opacity:"0"}, Power3.easeIn);
        tl.from(downTitle, 0.8,{y:200, opacity:"0", delay: 0.2}, Power3.easeIn);
        tl.to(image, 1, {y:-10, width: '60%' }, Power3.easeIn)
    }
    render(){
        
        return (
            <div className = "HeroBanner panel flex relative">
                <div className = "HeroBanner-midpage flex">
                    <div id = "title" className = "relative" > 
                        <h1 className = "upTitle">tienot_no</h1>
                    </div>
                    <div id = "title" className = "relative" > 
                        <h1 className = "downTitle">_aware</h1>
                    </div>
                    
                    <div className = "HeroBanner-story relative">
                            <h2 > <span>A short story ma</span>de by Etienne Glénat</h2>
                    </div>
                </div>
                <p className = "madeBy absolute"> @ made by Serotoninene</p>
                <div className= "HeroBanner-img absolute">
                    <motion.img src = {lac} className="resp" alt = "magnifique lac (et non magnifique alc)"></motion.img>
                </div>
            </div>
        )
    }
}

export default HeroBanner